export default "__VITE_ASSET__f6100914__"